import { TgglClient } from 'react-tggl-client'

export const tgglClient = new TgglClient(import.meta.env.VITE_TGGL_API_KEY)
